import { useMemo } from "react";
import { IAuditNote, TEditableAuditNote } from "../../interfaces/IAuditNote";
import { useAuditNoteContext } from "../../context/AuditNoteContext";
import { NoteID } from "../../utils/kierrokset.helper";

export type IUseEditableNotesHook = (fieldKey?: string) => {
    noteList: TEditableAuditNote[];
    addNote: (note: TEditableAuditNote) => void;
    updateNote: (id: number, updates: Partial<TEditableAuditNote>) => void;
    removeNote: (id: number) => void;

};

export const useEditableNotes: IUseEditableNotesHook = (fieldKey) => {
    const { notes, setNote, addNote, removeNote } = useAuditNoteContext();
    const noteIds = Object.keys(notes).filter((id) => !fieldKey || notes[id].key === fieldKey);

    const add = (note: TEditableAuditNote) => {
        addNote(note);
    };

    const remove = (id: TEditableAuditNote["id"]) => {
        removeNote(id);
    };

    const update = (id: number, updates: Partial<TEditableAuditNote>) => {
        const noteData = notes[String(id)];
        if (!noteData) {
            throw Error("Failed to find note by this id " + id);
        };

        setNote({ ...noteData as any, ...updates });
    };

    const noteList = useMemo(() => noteIds.map((id) => notes[id]), [fieldKey, noteIds, notes])

    return {
        noteList,
        updateNote: update,
        addNote: add,
        removeNote: remove
    }
}